import axiosInstance from "../utils/axios";

export const getPushStats = () => {
  return axiosInstance.get("/admin/push-notifications/stats");
};

export const getPushHistory = (limit = 50) => {
  return axiosInstance.get(
    `/admin/push-notifications/history?limit=${limit}`
  );
};

export const sendPushNotification = (data) => {
  return axiosInstance.post(
    "/admin/push-notifications/send",
    data
  );
};
